/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Radar_TitleInputs */

const en_directory_launch_radar_title = /** @type {(inputs: Directory_Launch_Radar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Launch Radar`)
};

const zh_directory_launch_radar_title = /** @type {(inputs: Directory_Launch_Radar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 发布雷达`)
};

/**
* | output |
* | --- |
* | "AI Launch Radar" |
*
* @param {Directory_Launch_Radar_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_radar_title = /** @type {((inputs?: Directory_Launch_Radar_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Radar_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_radar_title(inputs)
	return zh_directory_launch_radar_title(inputs)
});
export { directory_launch_radar_title as "directory.launch.radar_title" }